export default "__VITE_ASSET__FR8f$fJd__"